import {
    Component,
    Input,
    OnChanges,
} from '@angular/core';

import { DateUtils } from '../dateutils.service';

@Component({
    selector: 'week-picker',
    templateUrl: './WeekPicker.component.html',
    styleUrls: ['./WeekPicker.component.sass'],
})
export class WeekPicker implements OnChanges {

    dates : Date[] = []
    @Input() refDate : Date

    constructor(private dateutils : DateUtils) {}

    calculateDates() {

        if (this.refDate === undefined || this.refDate === null) {
            console.log("null/undefined refDate!")
            return;
        }

        // Sunday = 0, Monday = 1, ... Thursday = 4
        let refDay = this.refDate.getDay();
        if (refDay == 0) { refDay = 7; }
        let refTs = this.refDate.getTime();

        if (this.dates.length > 0) {
            if (this.dates[0].getTime() <= refTs && refTs <= this.dates[this.dates.length-1].getTime()) {
                return;
            }
        }

        // reset Dates
        this.dates.length = 0;

        let one_day = 1000 * 60 * 60 * 24;

        for (var i = 1; i < 8; i++) {
            let diff = refDay-i;
            this.dates.push(new Date(refTs - (diff * one_day)));
        }
    }

    isToday(date : Date) {
        return this.dateutils.isToday(date);
    }

    dayUrl(date : Date) : string[] {
        return this.dateutils.dayUrl(date);
    }

    dayName(date : Date) : string {
        return this.dateutils.dayName(date);
    }

    shortMonthName(date : Date) : string {
        return this.dateutils.shortMonthName(date);
    }

    classFor(date : Date) : string {
        if (this.dateutils.isToday(date)) {
            return "today";
        }
        return "";
    }

    ngOnChanges() {
        this.calculateDates();
    }

}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/cal/WeekPicker.component.ts